import { useRef, useEffect, useCallback } from 'react';
const OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT = 100;
export function useNotificationDropdownHover({ isNotificationsDropdownOpen , openNotificationsDropdown , closeNotificationsDropdown  }) {
    const openNotificationsDropdownTimerId = useRef();
    const closeNotificationsDropdownTimerId = useRef();
    const handleNotificationsDropdownHover = useCallback(()=>{
        openNotificationsDropdownTimerId.current = setTimeout(openNotificationsDropdown, OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT);
        clearTimeout(closeNotificationsDropdownTimerId.current);
    }, [
        openNotificationsDropdown
    ]);
    const handleNotificationsDropdownLeave = useCallback(()=>{
        clearTimeout(openNotificationsDropdownTimerId.current);
        closeNotificationsDropdown();
    }, [
        closeNotificationsDropdown
    ]);
    const handleNotificationsDropdownTouch = useCallback((e)=>{
        if (!isNotificationsDropdownOpen) {
            // default actions should only be prevented for the initial click
            // once the notification menu is shown, we want to let other touch
            // events pass through
            e.preventDefault();
        }
        handleNotificationsDropdownHover();
    }, [
        handleNotificationsDropdownHover,
        isNotificationsDropdownOpen
    ]);
    useEffect(()=>{
        return ()=>{
            clearTimeout(openNotificationsDropdownTimerId.current);
            // TODO: I'm not entirely sure why the linter hates this particular line...
            // eslint-disable-next-line react-hooks/exhaustive-deps
            clearTimeout(closeNotificationsDropdownTimerId.current);
        };
    }, []);
    return {
        handleNotificationsDropdownHover,
        handleNotificationsDropdownLeave,
        handleNotificationsDropdownTouch
    };
}
